// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import cntEntity from './entities/cnt.json';
import cntMenu from '../pages/cnt/menu.json';
import cntFullForm from '../pages/cnt/forms/full.json';
import cntContextForm from '../pages/cnt/forms/context.json';
import cntMiniForm from '../pages/cnt/forms/mini.json';
import cntLookupForm from '../pages/cnt/forms/lookup.json';
import cntTableView from '../pages/cnt/views/table.json';
import cntStagesView from '../pages/cnt/views/stages.json';
import cntCardsView from '../pages/cnt/views/cards.json';
import cntInlineView from '../pages/cnt/views/inline.json';
import cntBacklogView from '../pages/cnt/views/backlog.json';
import cntSplitView from '../pages/cnt/views/split.json';
import cntCalendarView from '../pages/cnt/views/calendar.json';
import cntDashboardView from '../pages/cnt/views/dashboard.json';

/** Тип запису «Контакт» зі сторінками пакета: меню, форми та подання з pages/cnt/. */
export const cntDefinition: IRecordTypeDefinition = {
  ...cntEntity,
  views: assembleViewSet({
      table: cntTableView,
      stages: cntStagesView,
      cards: cntCardsView,
      inline: cntInlineView,
      backlog: cntBacklogView,
      split: cntSplitView,
      calendar: cntCalendarView,
      dashboard: cntDashboardView,
  }),
  form: cntFullForm,
  forms: { full: cntFullForm, context: cntContextForm, mini: cntMiniForm, lookup: cntLookupForm },
  menu: cntMenu,
} as IRecordTypeDefinition;
